import { AppEnvParamsBrowser } from 'src/utils/appEnvParams';
import { createContext } from 'src/utils/createContext';
import { AutoWeakMap, autoWeakMapKey } from 'src_common/common/mobx-utils/AutoWeakMap';
import { Session } from 'src_common/sdk/session';
import { TrpcClient } from './TrpcClient';

export class Common {
    public [autoWeakMapKey] = (): void => {};

    public readonly trpcClient: TrpcClient;

    public constructor(
        public readonly appEnvParams: AppEnvParamsBrowser,
        public readonly session: Session
    ) {
        AutoWeakMap.register(this);

        this.trpcClient = new TrpcClient(session);
    }
}

const { AppContext, useContext } = createContext<Common>('Common');

export const ProviderCommon = AppContext.Provider;

export const useCommon = (): Common => {
    return useContext();
};
